import { useCart }     from '../../context/CartContext';
import { useUI }       from '../../context/UIContext';
import { useCurrency } from '../../context/CurrencyContext';
import { useState, useEffect } from 'react';
// const BASE   = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
// const imgSrc = (url) => !url ? null : url.startsWith('http') ? url : `${BASE}${url}`;

import { imgSrc } from '../../lib/env';
// const imgSrc = (url) => !url ? null : url.startsWith('http') ? url : `http://localhost${url}`;
export default function CartDrawer() {
  const { cartOpen, closeCart, openCheckout } = useUI();
  const { items, removeItem, updateQty, subtotal, totalItems } = useCart();
  const { fmt } = useCurrency();

  useEffect(() => {
  if (cartOpen) {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  } else {
    const scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);  // restore scroll position
  }
  return () => {
    const scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  };
}, [cartOpen]);

  return (
    <>
      {cartOpen && (
        <div onClick={closeCart} className="animate-fade-in"
          style={{ position: 'fixed', inset: 0, background: 'rgba(26,26,26,0.5)', zIndex: 150 }} />
      )}

      <div style={{
        position: 'fixed', top: 0, right: 0, height: '100%', width: '100%', maxWidth: 440,
        background: '#fff', zIndex: 151, display: 'flex', flexDirection: 'column',
        boxShadow: cartOpen ? 'var(--shadow-xl)' : 'none',
        transform: cartOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.32s cubic-bezier(0.16,1,0.3,1)',
      }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', borderBottom: '1px solid var(--grey)' }}>
          <div>
            <h2 style={{ fontSize: 13, fontWeight: 600, color: 'var(--dark)', letterSpacing: '0.08em' }}>YOUR BAG</h2>
            <p style={{ fontSize: 12, color: 'var(--grey-mid)', marginTop: 2 }}>
              {totalItems === 0 ? 'Empty' : `${totalItems} item${totalItems !== 1 ? 's' : ''}`}
            </p>
          </div>
          <button onClick={closeCart} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--grey-mid)', display: 'flex', alignItems: 'center', padding: 4 }}>
            <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        {/* Items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 24px' }}>
          {items.length === 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 16, textAlign: 'center' }}>
              <svg width={52} height={52} fill="none" stroke="var(--grey)" strokeWidth={1} viewBox="0 0 24 24">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
              <div>
                <p style={{ fontSize: 11, color: 'var(--grey-mid)', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 16 }}>Your bag is empty</p>
                <button onClick={closeCart} style={{ fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, padding: '10px 24px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer' }}>
                  Continue Shopping
                </button>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              {items.map((item) => (
                <div key={item.id} style={{ display: 'flex', gap: 14, paddingBottom: 20, borderBottom: '1px solid var(--grey-light)' }}>
                  {/* Thumb */}
                  <div style={{ width: 80, height: 96, flexShrink: 0, background: 'var(--cream)', overflow: 'hidden' }}>
                    {item.img && (
                      <img src={imgSrc(item.img)} alt={item.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', mixBlendMode: 'multiply' }} />
                    )}
                  </div>

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontSize: 10, color: 'var(--grey-mid)', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: 3, fontWeight: 500 }}>{item.brand}</p>
                    <p style={{ fontSize: 13, fontWeight: 500, color: 'var(--dark)', lineHeight: 1.3, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</p>
                    <p style={{ fontSize: 13, color: 'var(--dark)', fontWeight: 500 }}>{fmt(item.price)}</p>

                    {/* Qty controls */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
                      <button onClick={() => updateQty(item.id, item.qty - 1)}
                        style={{ width: 26, height: 26, border: '1px solid var(--grey)', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 15, color: 'var(--grey-dark)', transition: 'border-color 0.2s' }}
                        onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--dark)'}
                        onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--grey)'}>−</button>
                      <span style={{ fontSize: 12, minWidth: 16, textAlign: 'center', color: 'var(--dark)', fontWeight: 500 }}>{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)}
                        style={{ width: 26, height: 26, border: '1px solid var(--grey)', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 15, color: 'var(--grey-dark)', transition: 'border-color 0.2s' }}
                        onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--dark)'}
                        onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--grey)'}>+</button>
                      <button onClick={() => removeItem(item.id)}
                        style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--grey)', background: 'none', border: 'none', cursor: 'pointer', letterSpacing: '0.05em', transition: 'color 0.2s' }}
                        onMouseEnter={(e) => e.target.style.color = 'var(--red)'}
                        onMouseLeave={(e) => e.target.style.color = 'var(--grey)'}>Remove</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div style={{ padding: '20px 24px', borderTop: '1px solid var(--grey)', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 12, color: 'var(--grey-dark)' }}>Subtotal</span>
              <span style={{ fontSize: 16, fontWeight: 600, color: 'var(--dark)' }}>{fmt(subtotal)}</span>
            </div>
            <p style={{ fontSize: 11, color: 'var(--grey-mid)' }}>Shipping & taxes calculated at checkout</p>
            <button onClick={openCheckout}
              style={{ width: '100%', padding: '16px 0', background: 'var(--dark)', color: '#fff', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', fontWeight: 600, border: 'none', cursor: 'pointer', transition: 'background 0.2s' }}
              onMouseEnter={(e) => e.target.style.background = 'var(--gold)'}
              onMouseLeave={(e) => e.target.style.background = 'var(--dark)'}>
              Proceed to Checkout
            </button>
            <button onClick={closeCart}
              style={{ width: '100%', padding: '12px 0', background: '#fff', color: 'var(--dark)', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', fontWeight: 600, border: '1px solid var(--grey)', cursor: 'pointer' }}>
              Continue Shopping
            </button>
          </div>
        )}
      </div>
    </>
  );
}